import { Checkbox as MantineCheckbox } from '@mantine/core'
import { UseFormRegisterReturn } from 'react-hook-form'

interface CheckboxProps {
  label: string
  required?: boolean
  error?: string
  helperText?: string
  className?: string
  disabled?: boolean
  register?: UseFormRegisterReturn
  checked?: boolean
  onChange?: (checked: boolean) => void
  description?: string
}

export function Checkbox({
  label,
  required = false,
  error,
  helperText,
  className = '',
  disabled = false,
  register,
  checked,
  onChange,
  // description,
}: CheckboxProps) {
  const checkboxProps = register
    ? { ...register }
    : {
        checked,
        onChange: onChange
          ? (e: React.ChangeEvent<HTMLInputElement>) =>
              onChange(e.target.checked)
          : undefined,
      }

  return (
    <div className={`space-y-1 ${className}`}>
      <MantineCheckbox
        {...checkboxProps}
        label={
          <div>
            <span className="text-sm font-medium text-gray-700">
              {label}
              {required && <span className="text-red-500 ml-1">*</span>}
            </span>
          </div>
        }
        disabled={disabled}
        error={error}
        description={helperText}
        radius="sm"
        size="sm"
        styles={{
          error: {
            fontSize: 10,
          },
          input: {
            '&[data-checked]': {
              backgroundColor: '#2D5E8B',
              borderColor: '#2D5E8B',
            },
          },
          icon: {
            color: '#fff',
          },
        }}
      />
    </div>
  )
}
